import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, ViewEncapsulation, Input } from '@angular/core';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { Actions, ofActionCompleted, Select, Store } from '@ngxs/store';
import { QueryNodeInfoSuccess, QueryNodeInfoFailure, SetNodeInfo, ToggleVisibleNodes } from 'src/app/engine/state/nodes/engine.nodes.actions';
import { takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { ViewActions } from '../../state/view.actions';
import { ViewState } from '../../state/view.state';
import { ViewLayoutStatus } from '../../models/view-layout-status.enum';

@Component({
  selector: 'app-view-node-description',
  templateUrl: './view-node-description.component.html',
  styleUrls: ['./view-node-description.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewNodeDescriptionComponent implements OnInit, OnDestroy {
  // ---------- Observables ----------
  @Select(EngineNodesState.getSelectedNode)
  node$: Observable<ViewTreeNode>;

  @Select(EngineNodesState.getQuerying)
  querying$: Observable<boolean>;



  // ---------- Input / Output ----------
  @Input()
  layout: 'drawer' | 'column' = 'drawer';

  @Input()
  showClose = true;


  isOpen = false;


  // ---------- Class Variables ----------
  private ngUnsubscribe = new Subject();

  

  // ---------- Lifecycle ----------
  constructor(
    private store: Store,
    private actions: Actions, 
    private changeRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.initInfoListeners();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  // ---------- Interaction ----------
  handleHideClick(node: ViewTreeNode) {
    this.store.dispatch(new ToggleVisibleNodes([node], false));
  }

  handleCloseClick() {
    const layout = this.store.selectSnapshot(ViewState.getLayout);
    layout.nodeInfo.status = ViewLayoutStatus.Hide;
    this.store.dispatch(new ViewActions.SetLayout(layout));
  }



  // ---------- Methods ----------
  initInfoListeners() {
    // mark "dirty" check for node updates
    this.actions
      .pipe(
        ofActionCompleted(QueryNodeInfoSuccess, QueryNodeInfoFailure, SetNodeInfo),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(() => {
        this.isOpen = true;
        this.changeRef.markForCheck();
      });
  }

  formatHTML(text: string): string {
    return text
      .trim()
      .replace(new RegExp('\r?\n', 'g'), '<br><br>');
  }
}
